import { Panel, PanelBody, SelectControl, Button } from '@wordpress/components';

const SpacingControls = ({ attributes, setAttributes, spacingOptions, resetSpacing }) => {
    const {
        paddingTop,
        paddingBottom,
        paddingLeft,
        paddingRight,
        marginTop,
        marginBottom,
        marginLeft,
        marginRight,
        paddingTopMobile,
        paddingBottomMobile,
        paddingLeftMobile,
        paddingRightMobile,
        marginTopMobile,
        marginBottomMobile,
        marginLeftMobile,
        marginRightMobile,
    } = attributes;

    return (
        <Panel className='spacing_controls' header="Spacing controls">
            <PanelBody title="Padding Settings Desktop" initialOpen={false}>
                <SelectControl
                    label="Padding Top"
                    value={paddingTop}
                    options={spacingOptions}
                    onChange={(value) => setAttributes({ paddingTop: value })}
                />
                <SelectControl
                    label="Padding Bottom"
                    value={paddingBottom}
                    options={spacingOptions}
                    onChange={(value) => setAttributes({ paddingBottom: value })}
                />
                <SelectControl
                    label="Padding Left"
                    value={paddingLeft}
                    options={spacingOptions}
                    onChange={(value) => setAttributes({ paddingLeft: value })}
                />
                <SelectControl
                    label="Padding Right"
                    value={paddingRight}
                    options={spacingOptions}
                    onChange={(value) => setAttributes({ paddingRight: value })}
                />
            </PanelBody>
            <PanelBody title="Padding Settings Mobile" initialOpen={false}>
                <SelectControl
                    label="Mobile Padding Top"
                    value={paddingTopMobile}
                    options={spacingOptions}
                    onChange={(value) => setAttributes({ paddingTopMobile: value })}
                />
                <SelectControl
                    label="Mobile Padding Bottom"
                    value={paddingBottomMobile}
                    options={spacingOptions}
                    onChange={(value) => setAttributes({ paddingBottomMobile: value })}
                />
                <SelectControl
                    label="Mobile Padding Left"
                    value={paddingLeftMobile}
                    options={spacingOptions}
                    onChange={(value) => setAttributes({ paddingLeftMobile: value })}
                />
                <SelectControl
                    label="Mobile Padding Right"
                    value={paddingRightMobile}
                    options={spacingOptions}
                    onChange={(value) => setAttributes({ paddingRightMobile: value })}
                />
            </PanelBody>
            <PanelBody title="Margin Settings Desktop" initialOpen={false}>
                <SelectControl
                    label="Margin Top"
                    value={marginTop}
                    options={spacingOptions}
                    onChange={(value) => setAttributes({ marginTop: value })}
                />
                <SelectControl
                    label="Margin Bottom"
                    value={marginBottom}
                    options={spacingOptions}
                    onChange={(value) => setAttributes({ marginBottom: value })}
                />
                <SelectControl
                    label="Margin Left"
                    value={marginLeft}
                    options={spacingOptions}
                    onChange={(value) => setAttributes({ marginLeft: value })}
                />
                <SelectControl
                    label="Margin Right"
                    value={marginRight}
                    options={spacingOptions}
                    onChange={(value) => setAttributes({ marginRight: value })}
                />
            </PanelBody>
            <PanelBody title="Margin Settings Mobile" initialOpen={false}>
                <SelectControl
                    label="Mobile Margin Top"
                    value={marginTopMobile}
                    options={spacingOptions}
                    onChange={(value) => setAttributes({ marginTopMobile: value })}
                />
                <SelectControl
                    label="Mobile Margin Bottom"
                    value={marginBottomMobile}
                    options={spacingOptions}
                    onChange={(value) => setAttributes({ marginBottomMobile: value })}
                />
                <SelectControl
                    label="Mobile Margin Left"
                    value={marginLeftMobile}
                    options={spacingOptions}
                    onChange={(value) => setAttributes({ marginLeftMobile: value })}
                />
                <SelectControl
                    label="Mobile Margin Right"
                    value={marginRightMobile}
                    options={spacingOptions}
                    onChange={(value) => setAttributes({ marginRightMobile: value })}
                />
            </PanelBody>
            <PanelBody>
                <Button isPrimary onClick={resetSpacing}>
                    Reset All Styles
                </Button>
            </PanelBody>
        </Panel>
    );
};

export default SpacingControls;
